import React from 'react';
import './page.css';
import MainTitle from '../../components/page/main-title/MainTitle';
import ButtonAdd from '../../components/form/ButtonAdd';
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Container from '../../components/container/Container';
import Modal from '../../components/modal/Modal';
import Page from './Page';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import { Closest } from '../../utils/htmlnodes/Selectors';

const URL_REMOVE_ITEM = WS.planos_alimentares.remove;
const URL_LISTA = WS.planos_alimentares.lista;
const URL_DETALHE_ITEM = WS.planos_alimentares.detalhe;

class PlanosAlimentares extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      isLoading: true
    }

    this.handleClick = this.handleClick.bind(this);
    this.btEditClick = this.btEditClick.bind(this);
    this.remove = this.remove.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url:URL_LISTA,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  componentWillUnmount() {

  }

  onRemoveItem (e,data){
    Dialog.destroy();
    const {
      msgRemover,
      atencao,
      fechar,
      remover,
      itemRemovidoSucesso,
      impossivelRemoverItem,
      erroRemover
    } = this.state.strings;
    //----------------
    const id = data.id;
    const item = Closest(e,'.item-listagem');

    Requisitions({
      url:URL_REMOVE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;
        if(data.status){
          msg = {
            title: atencao,
            text: itemRemovidoSucesso
          };

          //remove o item
          item.remove();
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
        }
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroRemover
        });
      }
    });
    //----------------
  }

  remove (element) {
    const button = element.currentTarget;
    const {msgRemover,atencao,fechar,remover} = this.state.strings;
    const _self = this;
    const item = Closest(button,'.item-listagem');
    const id = item.getAttribute('data-id');

    this.checkId(id);

    Dialog.create({
      type: Dialog.CONFIRM,
      title: atencao,
      text: msgRemover,
      txtCancel: fechar,
      txtOk: remover,
      onSubmit: (el) => {
        _self.onRemoveItem(button,{id:id});
        el.preventDefault();
      }
    });
    element.preventDefault();
  }

  checkId (id){
    const {atencao,impossivelRemoverItem} = this.state.strings;
    if(!id){
      Dialog.create({
        title: atencao,
        text: impossivelRemoverItem
      });
      return false;
    }
  }

  btEditClick (e){
    const item = Closest(e.currentTarget,'.item-listagem');
    const id = item.getAttribute('data-id');
    const {atencao,erroDetalhe} = this.state.strings;
    this.checkId(id);

    const history = this.props.history;

    Requisitions({
      url:URL_DETALHE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;

        if(data.status){
          var modal = new Modal();
          modal.open({page:<Page modal={modal} detalhe={data.item} history={history} />});
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }

      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroDetalhe
        });
      }
    });

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  handleClick(e) {
    var modal = new Modal();
    modal.open({page:<Page modal={modal} history={this.props.history}  />});

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  render (){
    let lista = this.state.lista.map((value, i) =>
        <ItemSimplesListagem id={value.id} value={value.titulo} key={i} btEditClick={this.btEditClick}  btRemoveClick={this.remove}></ItemSimplesListagem>
      );

    if(lista.length<=0){
      lista = <EmptyList />
    }

    let wrapper = this.state.isLoading ? <LoadingPage /> : lista;

    const {planosAlimentares} = this.state.strings;

    return (
      <Container>
        <MainTitle title={planosAlimentares}></MainTitle>
        <ButtonAdd myClick={this.handleClick}></ButtonAdd>
          <div className="listagem">
            {wrapper}
          </div>
      </Container>
    );
  }
}



export default PlanosAlimentares;



// WEBPACK FOOTER //
// ./src/classes/planos-alimentares/PlanosAlimentares.js